<template>
  <div class="home-section">
    <HeroSection :workers="workers" @scroll-to-packages="handleScrollToPackages" />
    <PackagesSection ref="packagesSection" :packages="packages" />
    <ServicesSection :services="services" />
    <OurServicesSection />
    <AboutIt />
  </div>
</template>

<script>
import HeroSection from '@/components/HeroSection.vue';
import ServicesSection from '@/components/ServicesSection.vue';
import PackagesSection from '@/components/PackagesSection.vue';
import OurServicesSection from '@/components/OurServicesSection.vue';
import AboutIt from '@/components/AboutIt.vue';
import { getAllPackages } from '@/services/planService';
export default {
  name: 'HomePage',
  components: {
    HeroSection,
    ServicesSection,
    PackagesSection,
    OurServicesSection,
    AboutIt,
  },
  data() {
    return {
      workers: [
        {
          image: 'worker1.png',
          title: 'We are ready to give a hand',
          desc: 'Promise to provide a best service',
        },
        {
          image: 'worker2.png',
          title: 'Professional Cleaning Experts',
          desc: 'Making your home shine with care',
        },
        {
          image: 'worker3.png',
          title: 'Reliable & Affordable Service',
          desc: 'Your comfort is our priority',
        },
      ],
      services: [
        'Home Deep Cleaning & Pest Control Service',
        'Inspection & Maintenance Check',
        'Appliance Check (HVAC, Plumbing)',
        'Reorganization & Decluttering',
        'AC Servicing',
        'Furniture & Upholstery Cleaning',
        'Electrical & Plumbing Check',
        'Water Tank Cleaning',
      ],
      packages: [],
    };
  },
  mounted() {
    this.getAllPackages();
    this.$nextTick(() => {
      this.$root.$emit('home-mounted');
    });
  },

  methods: {
    async getAllPackages() {
      const data = await getAllPackages();
      this.packages = data?.data?.plans || [];
    },
    handleScrollToPackages() {
      const packagesSection = this.$refs.packagesSection.$el;
      if (packagesSection) {
        packagesSection.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
};
</script>
